import { render, staticRenderFns } from "./CentralOrder.vue?vue&type=template&id=8a468316&scoped=true&"
import script from "./CentralOrder.vue?vue&type=script&lang=js&"
export * from "./CentralOrder.vue?vue&type=script&lang=js&"
import style0 from "./CentralOrder.vue?vue&type=style&index=0&id=8a468316&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a468316",
  null
  
)

export default component.exports